import { render, staticRenderFns } from "./UploadAmazonS3Multiple.vue?vue&type=template&id=379f45d0&lang=pug&"
import script from "./UploadAmazonS3Multiple.vue?vue&type=script&lang=js&"
export * from "./UploadAmazonS3Multiple.vue?vue&type=script&lang=js&"
import style0 from "./UploadAmazonS3Multiple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports